<script>
// import simplebar from "simplebar-vue";
// import i18n from "../i18n";

export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/french.jpg"),
          language: "fr",
          title: "French",
        },
        {
          flag: require("@/assets/images/flags/spain.jpg"),
          language: "es",
          title: "spanish",
        },
        {
          flag: require("@/assets/images/flags/chaina.png"),
          language: "zh",
          title: "Chinese",
        },
        {
          flag: require("@/assets/images/flags/arabic.png"),
          language: "ar",
          title: "Arabic",
        },
      ],
      current_language: "en",
    };
  },
  // components: { simplebar },
  methods: {
    toggleMenu(e) {
      e.stopPropagation();
      this.$parent.toggleMenu();
      this.$emit("handleMenuClick");
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    // setLanguage(locale) {
    //   i18n.locale = locale;
    //   this.current_language = i18n.locale;
    // },
    getUsername() {
      let user = JSON.parse(localStorage.getItem("user"));
      if (user) {
        return user.user.name;
      }
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box" v-if="false">
          <a
            href="index.html"
            class="logo logo-dark"
            style="text-align: center"
          >
            <span class="logo-sm">
              <img src="@/assets/Dil-Foods-new-logo.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/Dil-Foods-new-logo.png" alt height="80" />
            </span>
          </a>

          <a
            href="index.html"
            class="logo logo-light"
            style="text-align: center"
          >
            <span class="logo-sm">
              <img src="@/assets/Dil-Foods-new-logo.png" alt height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/Dil-Foods-new-logo.png" alt height="80" />
            </span>
          </a>
        </div>

        <button
          @click="toggleMenu"
          type="button"
          class="btn btn-sm px-3 font-size-24 header-item waves-effect"
          id="vertical-menu-btn"
        >
          <i class="ri-menu-2-line align-middle"></i>
        </button>
      </div>

      <div class="d-flex">
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          class="d-inline-block user-dropdown"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/user-icon.png"
              alt="Header Avatar"
              style="height: 41px"
            />
            <span class="d-none d-xl-inline-block ml-1">{{
              getUsername()
            }}</span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <!-- item-->
          <div class="dropdown-divider"></div>
          <router-link to="/logout">
            <a class="dropdown-item text-danger" href="javascript:void(0);">
              <i class="ri-shut-down-line align-middle mr-1 text-danger"></i>
              {{ "navbar.dropdown.kevin.list.logout" }}
            </a>
          </router-link>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.notify-item {
  .active {
    color: #16181b;
    background-color: #f8f9fa;
  }
}
</style>
